import { render, staticRenderFns } from "./ChildIcon.vue?vue&type=template&id=c64e1258&scoped=true&lang=pug"
import script from "./ChildIcon.vue?vue&type=script&lang=js"
export * from "./ChildIcon.vue?vue&type=script&lang=js"
import style0 from "./ChildIcon.vue?vue&type=style&index=0&id=c64e1258&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64e1258",
  null
  
)

export default component.exports